import { render, staticRenderFns } from "./StoryReel.vue?vue&type=template&id=3ed544ef&scoped=true"
import script from "./StoryReel.vue?vue&type=script&lang=js"
export * from "./StoryReel.vue?vue&type=script&lang=js"
import style0 from "./StoryReel.vue?vue&type=style&index=0&id=3ed544ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed544ef",
  null
  
)

export default component.exports